module.exports = __webpack_public_path__ + "img/address.393878bf.png";